import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { setData} from 'src/storage/general.actions';
import { Router } from '@angular/router';
import { GeneralDataService } from 'src/app/services/general/general-data.service';

@Component({
  selector: 'app-tenemos-tus-datos',
  templateUrl: './tenemos-tus-datos.component.html',
  styleUrl: './tenemos-tus-datos.component.scss'
})
export class TenemosTusDatosComponent {
  private store = inject(Store);
  private generalDataService = inject(GeneralDataService);
  router = inject(Router);
  body: any;

  cleanStore(){
    this.store.dispatch(setData({
      key: 'Property',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'Tenant',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'PolicyHolder',
      value: undefined,
      merge: false
    }));
  }

  goBack(){
    this.cleanStore();
    this.router.navigate(['/seguros/hogar/arriendo/cotizador']).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }
}
